export class CustomPeriodModel {
  public id: string;
  public venueId: string;
  public startDateTime: string;
  public endDateTime: string;
  public rangeStartTime: string;
  public rangeEndTime: string;
}
